import axios from "axios";
import {AircraftEntryType, AirlineEntryType, log} from "./Tools";

export interface AirlineType {
    [key: string]: AirlineEntryType
}

export interface AircraftType {
    [key: string]: AircraftEntryType
}

interface AirlinesFunction {
    (): AirlineType
}

interface AircraftsFunction {
    (): AircraftType
}

const AirlinesRefreshFunction = (() => {
    const cached = localStorage.getItem('Airlines');
    log('get airlines', !!cached);
    if (cached && cached !== 'undefined') {
        const content = JSON.parse(cached);
        log('cached ', Object.keys(content).length);
        return () => content;
    } else {
        let result = {};
        axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/airlines')
            .then(response => {
                result = response.data;
                localStorage.setItem('Airlines', JSON.stringify(result));
            })
            .catch(error => log('airlines failed', error));
        return () => result;
    }
});

export let Airlines: AirlinesFunction = AirlinesRefreshFunction();

export const refreshAirlines = (() => {
    Airlines = AirlinesRefreshFunction();
})

export const Aircrafts: AircraftsFunction = (() => {
    const cached = localStorage.getItem('Aircrafts');
    log('get aircrafts', cached);
    if (cached && cached !== 'undefined') {
        return () => JSON.parse(cached);
    } else {
        let result: any = [];
        axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/aircrafts')
            .then(response => {
                result = response.data;
                localStorage.setItem('Aircrafts', JSON.stringify(result));
            })
            .catch(error => log('aircrafts failed', error));
        return () => result;
    }
})();

export const Countries = ((): any => {
    let result: any = [];
    const cached = localStorage.getItem('Countries');
    log('get countries', cached, typeof cached);
    if (cached && cached !== 'undefined') {
        result = JSON.parse(cached);
        return () => result;
    } else {
        axios.get('https://flightlogmap-backend.firebaseapp.com/api/v1/countries')
            .then(response => {
                result = response.data;
                localStorage.setItem('Countries', JSON.stringify(result));
            })
            .catch(error => log('countries failed', error));
        return () => result;
    }
})();
